import React from "react";
import styles from "./Card.module.css";

export default function Card({
  children,
  title = "",
  subtitle = "",
  headerAction = null,
  footer = null,
  variant = "default", // default | elevated | outlined | accent
  clickable = false,
  onClick,
  className = "",
  bodyClassName = "",
}) {
  const hasHeader = title || subtitle || headerAction;

  const cardClassName = [
    styles.card,
    styles[variant],
    clickable ? styles.clickable : "",
    className,
  ].join(" ");

  const content = (
    <>
      {hasHeader ? (
        <div className={styles.header}>
          <div className={styles.headerText}>
            {title ? <h3 className={styles.title}>{title}</h3> : null}
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>

          {headerAction ? (
            <div className={styles.headerAction}>{headerAction}</div>
          ) : null}
        </div>
      ) : null}

      <div className={[styles.body, bodyClassName].join(" ")}>
        {children}
      </div>

      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </>
  );

  if (clickable) {
    return (
      <button
        type="button"
        className={cardClassName}
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  return <div className={cardClassName}>{content}</div>;
}